import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Reveal } from "@/components/Motion";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <Reveal>
        <form onSubmit={submit} className="glass rounded-3xl p-10 w-full max-w-md border border-white/10" data-testid="admin-login-form">
          <Lock className="text-cyan mb-5" size={28} />
          <h1 className="font-display text-4xl mb-2">Admin access</h1>
          <p className="text-white/50 text-sm mb-8">Manage corals, fish and auctions.</p>
          <label className="mono-label text-white/40 block mb-2">Email</label>
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required data-testid="login-email"
            className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 mb-5 focus:border-cyan outline-none" />
          <label className="mono-label text-white/40 block mb-2">Password</label>
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required data-testid="login-password"
            className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 mb-8 focus:border-cyan outline-none" />
          <button disabled={busy} data-testid="login-submit" className="btn-pill btn-solid w-full">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
      </Reveal>
    </div>
  );
}
